export default __webpack_public_path__ + "static/media/1_7.aff8a734.png";